module.exports = __webpack_public_path__ + "static/media/ic_family_account.6e84cbf8.svg";